__turbopack_context__.v({
  "carousel-skeleton": "GStK2a_carousel-skeleton",
  "carousel-skeleton__card-row": "GStK2a_carousel-skeleton__card-row",
  "carousel-skeleton__title-skeleton": "GStK2a_carousel-skeleton__title-skeleton",
  "carousel-skeleton__title-skeleton-wrapper": "GStK2a_carousel-skeleton__title-skeleton-wrapper",
});
